import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary capturou:', error, info);
        this.setState({ info });
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, info: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center p-6 bg-slate-950">
                    <div className="max-w-xl w-full bg-slate-900 border border-red-900/50 rounded-sm p-6" data-testid="error-boundary">
                        <h2 className="text-xl text-red-400 font-heading mb-2">
                            Ocorreu um erro ao carregar esta página
                        </h2>
                        <p className="text-slate-400 text-sm mb-4">
                            Algo inesperado aconteceu. Tente recarregar a página. Se o problema persistir, contate o suporte.
                        </p>
                        <pre className="text-[11px] text-red-300 bg-slate-950 p-3 rounded-sm overflow-auto max-h-40 mb-4 font-mono">
                            {String(this.state.error?.message || this.state.error || 'Erro desconhecido')}
                        </pre>
                        <div className="flex gap-2">
                            <button
                                onClick={() => window.location.reload()}
                                className="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-mono uppercase rounded-sm"
                                data-testid="btn-reload-error"
                            >
                                Recarregar
                            </button>
                            <button
                                onClick={() => { window.location.href = '/dashboard'; }}
                                className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white text-sm font-mono uppercase rounded-sm"
                                data-testid="btn-dashboard-error"
                            >
                                Ir para Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
